import { showGlobalLoading } from "@/components/globalLoading";
import useRouter from "@/hooks/useRouter";
import { pxToRem } from "@/util/common";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import "./style/index.scss";
import API from "@/api";
import { isEmpty } from "lodash";
import { Dialog, FloatingBubble, Space, Image, Toast } from "antd-mobile";
import useCustomTranslation from "@/hooks/useTranslation";
import { isDef } from "@/util/validate";
import { useDispatch } from "react-redux";
import { AppDispatch } from "@/redux/store";
import { postApiFinanceBalance } from "@/redux/reducers/authSlice";

const UniversalComp: React.FC = () => {
	const dispatch: AppDispatch = useDispatch();
	const { hideLoading, showLoading } = showGlobalLoading();
	const [rawHtml, setRawHtml] = useState<string | null>();
	const [iframeUrl, setIframeUrl] = useState<string>();
	const { goBack } = useRouter();
	const [params] = useSearchParams();
	const timer = useRef<NodeJS.Timeout>();
	const { t } = useCustomTranslation();
	const htmlRef = useRef<any>();
	const location = useLocation(); // 使用 useLocation 获取当前 URL
	// 从 location.state 中获取 params
	const shouldDecode = location.state?.shouldDecode; // 获取 shouldDecode 参数
	const tempUrl = location.state?.url;

	useEffect(() => {
		if (isDef(htmlRef.current) && isDef(rawHtml)) {
			setHTMLWithScript(htmlRef.current, rawHtml);
		}
	}, [htmlRef, rawHtml]);

	useEffect(() => {
		const type = params.getAll("type")[0];
		if (type === "1") {
			let html: string | null = localStorage.getItem("gameHtml");
			setRawHtml(html);
		} else {
			// let iframeUrl = params.getAll("url")[0];
			// if (iframeUrl) {
			// 	iframeUrl = decodeURIComponent(iframeUrl);
			// }
			let iframeUrl = params.getAll("url")[0];
			console.log("shouldDecode==", shouldDecode);
			console.log("iframeUrl前===", iframeUrl);
			if (iframeUrl && shouldDecode) {
				iframeUrl = decodeURIComponent(iframeUrl);
			}
			if (!shouldDecode && tempUrl) {
				iframeUrl = tempUrl;
			}
			console.log("iframeUrl后=", iframeUrl);
			setIframeUrl(iframeUrl);
		}

		checkGame();
		return () => {
			timer.current && clearTimeout(timer.current);
		};
	}, [location.state]);

	const loadGameHall = () => {
		return API.games
			.apiGetGameHall({ mobile: true })
			.then((response: any) => {
				if (response.code === 0) {
					return response.content.data.entry;
				}
				return null;
			});
	};

	const checkGame = async () => {
		try {
			const response: any = await API.games.apiCheckGame();
			if (response?.code && !isEmpty(response.message)) {
				Dialog.alert({
					title: response.message,
					confirmText: t("Confirm"),
					onConfirm: () => {
						backPage();
					},
				});
				return;
			}
		} catch {}
		timer.current = setTimeout(() => {
			checkGame();
		}, 30000);
	};

	const handleIframeLoad = () => {
		hideLoading();
	};

	const backPage = async () => {
		try {
			await dispatch(postApiFinanceBalance({ itemTypes: [1] }));
			goBack();
		} catch (error) {
			Toast.show({
				content: t("LoadDataFailed"),
				position: "top",
			});
		}
	};

	const backLobby = () => {
		showLoading();
		loadGameHall()
			.then((s) => {
				if (!isEmpty(s)) {
					setIframeUrl("");
					setIframeUrl(s!);
				}
			})
			.catch(() => {
				Toast.show({
					content: t("LoadGameLobbyFailed"),
					position: "top",
				});
				hideLoading();
			});
	};

	const runScript = (script: any) => {
		return new Promise<void>((reslove, rejected) => {
			// 直接 document.head.appendChild(script) 是不会生效的，需要重新创建一个
			const newScript = document.createElement("script");
			// 获取 inline script
			newScript.innerHTML = script.innerHTML;
			// 存在 src 属性的话
			const src = script.getAttribute("src");
			if (src) newScript.setAttribute("src", src);

			// script 加载完成和错误处理
			newScript.onload = () => reslove();
			newScript.onerror = (err) => rejected();
			document.head.appendChild(newScript);
			document.head.removeChild(newScript);
			if (!src) {
				// 如果是 inline script 执行是同步的
				reslove();
			}
		});
	};

	const setHTMLWithScript = (container: HTMLElement, rawHTML: string) => {
		container.innerHTML = rawHTML;
		const scripts = container.querySelectorAll("script");

		return Array.prototype.slice.apply(scripts).reduce((chain, script) => {
			return chain.then(() => runScript(script));
		}, Promise.resolve());
	};

	return (
		<div className="router-view partnergame">
			{iframeUrl?.length ? (
				<iframe
					src={iframeUrl}
					frameBorder="0"
					id="gameIframe"
					allowFullScreen
					sandbox="allow-forms allow-scripts allow-same-origin allow-top-navigation"
					onLoad={handleIframeLoad}
					onError={handleIframeLoad}
					style={{
						width: "100%",
						height: "100%",
						backgroundColor: "#000",
					}}
				></iframe>
			) : rawHtml?.length ? (
				<div
					ref={htmlRef}
					style={{
						width: "100%",
						height: "100%",
						background: "#fff",
					}}
				></div>
			) : null}
			{rawHtml?.length ? null : (
				<FloatingBubble axis="xy" className="bubble">
					<Space
						block
						direction="horizontal"
						className="bubble-content"
						justify="between"
						style={{ "--gap": "0" }}
					>
						<Space
							className="bubble-item"
							align="center"
							justify="center"
							onClick={backPage}
						>
							<Image
								src={require("@/assets/images/icons/logo_small.png")}
								width={pxToRem(28)}
								height={pxToRem(28)}
							/>
						</Space>
						{/* {isEmpty(routerParams.type) && (
						<Space
							className="bubble-item"
							align="center"
							justify="center"
							style={{
								"--gap": pxToRem(4),
								borderLeft: "1px solid #2F3A62",
							}}
							onClick={backLobby}
						>
							<Image
								src={require("@/assets/images/game/game_lobby.png")}
								width={pxToRem(19)}
								height={pxToRem(26)}
							/>
							<Image
								src={require("@/assets/images/game/game_lobby_text.png")}
								width={pxToRem(30)}
								style={{ marginTop: pxToRem(7) }}
							/>
						</Space>
					)} */}
					</Space>
				</FloatingBubble>
			)}
		</div>
	);
};

export default UniversalComp;
